import { themr } from '@friendsofreactjs/react-css-themr';
import Alert from './Alert';

export const severityTypes = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};

export default themr('Alert')(Alert);
